import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=0c745ee9&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=0c745ee9&prod&lang=scss"
import style1 from "./GeneralInfo.vue?vue&type=style&index=1&id=0c745ee9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c745ee9",
  null
  
)

export default component.exports